function mvSetCozy(enabled) {
  document.body.toggleAttribute('data-mv-night', enabled);
  document.querySelectorAll('[data-mv-cozy]').forEach(button => button.setAttribute('aria-pressed', String(enabled)));
  try { localStorage.setItem('maro-vellin-cozy', enabled ? 'on' : 'off'); } catch (_) {}
}
try { mvSetCozy(localStorage.getItem('maro-vellin-cozy') === 'on'); } catch (_) {}
document.addEventListener('shopify:section:load', () => mvSetCozy(document.body.hasAttribute('data-mv-night')));
document.addEventListener('click', event => {
  if(event.target.closest('[data-mv-cozy]')) mvSetCozy(!document.body.hasAttribute('data-mv-night'));
});
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.mv-buy-form');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button');
  const status = form.querySelector('.mv-form-status');
  if (button.disabled) return;
  const label = button.innerHTML;
  const drawer = document.querySelector('cart-drawer');
  const addingInsideDrawer = Boolean(form.closest('cart-drawer'));
  const formData = new FormData(form);
  if (drawer) {
    formData.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
    formData.append('sections_url', window.location.pathname);
    drawer.setActiveElement(button);
  }
  button.disabled = true;
  button.textContent = 'Adding to your bag…';
  status.hidden = true;
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:formData});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || 'We couldn’t add this item. Please try again.');
    if (drawer && result.sections && Object.values(result.sections).every(Boolean)) {
      drawer.classList.remove('is-empty');
      drawer.renderContents(result);
      if (addingInsideDrawer) {
        drawer.setActiveElement(document.querySelector('#cart-icon-bubble'));
        const dialog = drawer.querySelector('.drawer__inner');
        trapFocus(dialog, dialog);
      }
    } else {
      window.location.assign(window.Shopify.routes.root + 'cart');
    }
  } catch (error) {
    status.textContent = error.message === 'Failed to fetch' ? 'We couldn’t reach the store. Check your connection and try again.' : error.message;
    status.hidden = false;
  } finally {
    button.disabled = false;
    button.innerHTML = label;
  }
});

function mvInitVideoSliders(root = document) {
  root.querySelectorAll('[data-mv-video-slider]').forEach(slider => {
    if (slider.dataset.mvInitialized) return;
    slider.dataset.mvInitialized = 'true';
    const track = slider.querySelector('.mv-video-track');
    const previous = slider.querySelector('[data-mv-slide="-1"]');
    const next = slider.querySelector('[data-mv-slide="1"]');
    const update = () => {
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    slider.querySelectorAll('[data-mv-slide]').forEach(button => button.addEventListener('click', () => {
      const slide = track.querySelector('.mv-video-slide');
      const distance = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
      track.scrollBy({left: Number(button.dataset.mvSlide) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }));
    track.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(track);
    slider.querySelectorAll('video').forEach(video => video.addEventListener('play', () => {
      document.querySelectorAll('[data-mv-video-slider] video').forEach(other => { if (other !== video) other.pause(); });
    }));
    update();
  });
}
mvInitVideoSliders();
document.addEventListener('shopify:section:load', () => mvInitVideoSliders());
document.addEventListener('click',(event)=>{
  const link=event.target.closest('[data-mv-back-to-product]');
  if (!link) return;
  const target=document.querySelector('product-info');
  if(target){event.preventDefault();target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});const heading=target.querySelector('h1');if(heading){heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true});}}
});

// The drawer add-on selects a real Shopify variant and its corresponding image.
document.addEventListener('change', event => {
  const select = event.target.closest('[data-mv-socks-variant]');
  if (!select) return;
  const card = select.closest('[data-mv-socks]');
  const option = select.selectedOptions[0];
  const image = card.querySelector('.mv-socks-image img');
  if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
  card.querySelector('[data-mv-socks-price]').textContent = option.dataset.price;
  card.querySelector('[data-mv-socks-link]').href = option.dataset.url;
});

// Revalidate cart HTML when returning from checkout or restored history.
// The marker covers browsers that restore a cached response without BFCache.
document.addEventListener('submit', (event) => {
  if (event.submitter?.name === 'checkout') {
    try { sessionStorage.setItem('mv-returning-from-checkout', '1'); } catch (_) {}
  }
}, true);
window.addEventListener('pageshow', (event) => {
  let returning = false;
  try {
    returning = sessionStorage.getItem('mv-returning-from-checkout') === '1';
    sessionStorage.removeItem('mv-returning-from-checkout');
  } catch (_) {}
  const historyRestore = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
  if (event.persisted || returning || historyRestore) {
    document.querySelector('cart-drawer')?.close();
    window.location.reload();
  }
});
